import React, { useCallback } from 'react';
import { _ } from '@splunk/ui-utils/i18n';
import ControlStop from '@splunk/react-icons/ControlStop';
import { ActionButton, useActionButtonClick } from '../ActionButton';
import type { BaseButtonProps } from '../BaseButton';
import { getButtonTitle } from '../utils/getButtonTitle';

const stopIcon = <ControlStop variant="filled" />;

export const FinalizeSearchButton = ({
    itemId,
    dashboardApi,
    screenReaderText,
    itemDefinition,
    ...rest
}: BaseButtonProps): JSX.Element | null => {
    const finalizeSearch = useCallback(() => {
        if (typeof itemId !== 'string') {
            return;
        }

        // dashboardApi and itemId have to exist to execute this callback
        dashboardApi?.finalize(itemId);
    }, [dashboardApi, itemId]);

    const handleOnClick = useActionButtonClick(
        'finalizeSearch',
        finalizeSearch
    );

    const buttonTitle = getButtonTitle({
        base: _('Stop search'),
        screenReaderText,
    });

    if (!itemId || !dashboardApi || !itemDefinition?.dataSources?.primary) {
        return null;
    }

    // if this button is to be used for more than just testing then it shouldn't render when the controller does not support control actions
    // can get controller with: dashboardApi.getDataSourceRegistry()?.getDataSourceController(itemDefinition.dataSources.primary)

    return (
        <ActionButton
            {...rest}
            data-test="finalize-search-button"
            onClick={handleOnClick}
            icon={stopIcon}
            title={buttonTitle}
        />
    );
};
